export default {
  'storeValueCard.title': '儲值卡',
  'storeValueCard.current_balance': '目前餘額',
  'storeValueCard.currency': '元',
  'storeValueCard.online_top_up': '線上儲值',
  'storeValueCard.deduct': '扣款',
  'storeValueCard.transaction_history': '交易紀錄',
  'storeValueCard.update_time': '更新時間',
  'storeValueCard.total_amount': '金額',
  'storeValueCard.store': '門市',
  'storeValueCard.empty': '目前沒有交易紀錄',
  'storeValueCard.redeem.title': '扣款',
  'storeValueCard.redeem.enter_amount': '請輸入扣款金額',
  'storeValueCard.redeem.enter_store_code': '請輸入核銷代碼',
  'storeValueCard.redeem.next_step': '下一步',
  'storeValueCard.redeem.success': '扣款成功',
  'storeValueCard.redeem.fail': '扣款失敗',
  'storeValueCard.description.title': '使用說明',
  'storeValueCard.store.title': '線上儲值',
  'storeValueCard.store.coupon_alt': '儲值優惠券',
  'storeValueCard.store.amount_prefix': '儲值金 {name}',
  'storeValueCard.store.description': '使用線上刷卡完成儲值，儲值金可於各門市消費時使用',
  'storeValueCard.store.top_up': '儲值',
  'storeValueCard.store.empty': '品牌尚未設定儲值面額',
} as Record<string, string>;
